import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "*",
      name: "index",
      meta: {
        divHelper: "g-doc",
        title: "课程列表"
      },
      component: () => import("./List.vue")
    },
    {
      path: "/course/list",
      name: "list",
      meta: {
        divHelper: "g-doc",
        title: "课程列表"
      },
      props: route => ({
        p: Number(route.query.p) || undefined,
        s: Number(route.query.s) || undefined,
        d: Number(route.query.d) || undefined
      }),
      component: () => import("./List.vue")
    },
    {
      path: "/course/rankIndex",
      name: "rankIndex",
      meta: {
        divHelper: "g-doc",
        title: "课程列表"
      },
      component: () => import("./rankIndex.vue")
    }
  ]
});
